import actions from './constants';

export const fetchDatasetCollections = (category, code) => ({
  type: actions.FETCH_DATASET_COLLECTIONS,
  category,
  code,
});

export const showDatasetCollections = (category, code, name, results) => ({
  type: actions.SHOW_DATASET_COLLECTIONS,
  category,
  code,
  name,
  results,
});

export const showDatasetCollectionsError = (category, code, error) => ({
  type: actions.SHOW_DATASET_COLLECTIONS_ERROR,
  category,
  code,
  error,
});

export const addDatasetCollectionsSuccess = (code, items) => ({
  type: actions.ADD_DATASET_COLLECTIONS_SUCCESS,
  code,
  items,
});

export const showAddDatasetCollections = (category, code, name) => ({
  type: actions.SHOW_ADD_DATASET_COLLECTIONS,
  category,
  code,
  name,
});

export const hideAddDatasetCollections = (category, code) => ({
  type: actions.HIDE_ADD_DATASET_COLLECTIONS,
  category,
  code,
});

export const showRemoveDatasetCollectionConfirmation = (category, code, collectionCode, name) => ({
  type: actions.SHOW_REMOVE_DATASET_COLLECTION_CONFIRMATION,
  category,
  code,
  collectionCode,
  name,
});

export const hideRemoveDatasetCollectionConfirmation = () => ({
  type: actions.HIDE_REMOVE_DATASET_COLLECTION_CONFIRMATION,
});

export const removeDatasetCollection = (category, code, collectionCode, name) => ({
  type: actions.REMOVE_DATASET_COLLECTION,
  category,
  code,
  collectionCode,
  name,
});

export const removeDatasetCollectionSuccess = (category, code, collectionCode, name) => ({
  type: actions.REMOVE_DATASET_COLLECTION_SUCCESS,
  category,
  code,
  collectionCode,
  name,
});

export const removeDatasetCollectionError = (category, code, collectionCode, error, name) => ({
  type: actions.REMOVE_DATASET_COLLECTION_ERROR,
  category,
  code,
  collectionCode,
  error,
  name,
});

export const fetchDatasetCollectionsAssignable = (category, code, filter) => ({
  type: actions.FETCH_DATASET_COLLECTIONS_ASSIGNABLE,
  category,
  code,
  filter,
});

export const fetchDatasetCollectionsAssignableSuccess = (category, code, results, resultsCount) => ({
  type: actions.FETCH_DATASET_COLLECTIONS_ASSIGNABLE_SUCCESS,
  category,
  code,
  results,
  resultsCount,
});

export const fetchDatasetCollectionsAssignableError = (category, code, error) => ({
  type: actions.FETCH_DATASET_COLLECTIONS_ASSIGNABLE_ERROR,
  category,
  code,
  error,
});

export const addDatasetCollections = () => ({
  type: actions.ADD_DATASET_COLLECTIONS,
});

export const removeDatasetCollectionAssignable = (category, code, collectionCode) => ({
  type: actions.REMOVE_DATASET_COLLECTION_ASSIGNABLE,
  category,
  code,
  collectionCode,
});

export const updateDatasetCollectionsAssignableProperties = (properties) => ({
  type: actions.UPDATE_DATASET_COLLECTIONS_ASSIGNABLE_PROPERTIES,
  properties,
});

export const updateDatasetUnassignedCollectionsProperties = (category, code, properties) => ({
  type: actions.UPDATE_DATASET_UNASSIGNED_COLLECTIONS_PROPERTIES,
  category,
  code,
  properties,
});

export const addDatasetCollectionsAssignable = (category, code) => ({
  type: actions.ADD_DATASET_COLLECTIONS_ASSIGNABLE,
  category,
  code,
});

export const addDatasetCollectionSuccess = (code, name, collections) => ({
  type: actions.ADD_DATASET_COLLECTIONS_SUCCESS,
  code,
  name,
  items: collections,
});

export const addDatasetCollectionsError = (errors) => ({
  type: actions.ADD_DATASET_COLLECTIONS_ERROR,
  errors,
});
